import { Link } from '@uhg-abyss/web/ui/Link';
import { Box } from '@uhg-abyss/web/ui/Box';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { useCollapse } from '@uhg-abyss/web/hooks/useCollapse';

export const ProcessingStatItem = ({ title, children }) => {
  const { collapseProps, buttonProps, isOpen } = useCollapse({
    defaultIsOpen: false,
  });
  return (
    <>
      <Link
        {...buttonProps}
        css={{
          alignItems: 'center',
          color: '$web.semantic.color.text.content.primary',
          display: 'flex',
          justifyContent: 'space-between',
          minHeight: '45px',
          fontSize: '$web.core.font-size.p.60',
          fontWeight: 'bold',
          borderBottom:
            '1px solid $web.semantic.color.border.content.secondary',
          padding: '0 20px',
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            bottom: '0px',
            left: '50%',
            width: '0px',
            height: '2px',
            backgroundColor: '#0C55B8',
            transition: 'width 300ms ease-in-out, left 300ms ease-in-out',
          },
          '&:hover': {
            borderColor: '#0C55B8',
            color: '#0C55B8',
            textDecoration: 'none',
            cursor: 'pointer',
            transition: '300ms ease-in-out',
          },
          '&:hover::before': {
            width: '100%',
            left: '0px',
          },
        }}
      >
        {title}
        <IconSymbol
          icon={isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
          color="$web.semantic.color.icon.interactive.rest.tertiary"
          size="24px"
        />
      </Link>
      <div {...collapseProps}>
        <Box
          padding="16px"
          css={{
            'abyss-box-root': {
              backgroundColor: 'transparent',
            },
          }}
        >
          {children}
        </Box>
      </div>
    </>
  );
};
